import SkapaBadge, { type BadgeProps } from "@ingka/badge";

const Badge = (props: BadgeProps) => {
  return <SkapaBadge prefix="saleslead__" {...props} />;
};

export { Badge, type BadgeProps };
